import React from "react";
import PanelHead from "../../../Panel/PanelHead";
import PanelBody from "../../../Panel/PanelBody";
import SkypeGroupTable from "./SkypeGroupTable";

const SkypeGroupList = () => {
  return (
    <div>
      <PanelHead title="Skype Groups" />
      <PanelBody content={<SkypeGroupTable />} />
    </div>
  );
};

export default SkypeGroupList;
